/**
 * The Transport (A4) list always shows one Default row; these two decide when the step has to add it.
 *
 * `transport.isDefault` here means "this row is the project's Default row" — the row the settings page
 * locks and that `project_transport_default` points at once saved. `toTransportTypes` sets it from that
 * pointer on the way in from Hasura — for the working state's rows and for a previewed revision's own,
 * which the revisions store maps through the same function — and `Transport.vue` sets it on the row it
 * synthesises. A previewed revision never reaches these helpers: its list is displayed as it is, and a
 * Default row is only ever minted into the WORKING list.
 */

type RowLike = { transport: { isDefault: boolean } };

export const hasDefaultRow = (rows: readonly RowLike[]): boolean => rows.some((row) => row.transport.isDefault);

/**
 * The list with a Default row in front of it when it has none, or the SAME array when it already has one.
 *
 * Same array, not a copy, so a watcher that assigns the result back never re-triggers itself. And the
 * generic rows are kept: the step used to replace the whole list with `[default]` whenever a Default was
 * missing, which threw away every row the user had added (RTLCA-5772).
 */
export const withDefaultRow = <T extends RowLike>(rows: T[], makeDefault: () => T): T[] =>
  hasDefaultRow(rows) ? rows : [makeDefault(), ...rows];
